/**
 * A repository for the token.
 */
export abstract class TokenRepo {
  /**
   * Saves the token for later retrieval with the {@link get} method.
   * @param token
   */
  abstract save(token: string): void;

  /**
   * Returns the saved token.
   */
  abstract get(): string | null;

  /**
   * Removes the saved token.
   */
  abstract remove(): void;

  /**
   * Saves the token for later retrieval with the {@link getTemporal} method.
   * @param token
   */
  abstract saveTemporal(token: string): void;

  /**
   * Returns the temporally saved token.
   */
  abstract getTemporal(): string | null;

  /**
   * Removes the temporally saved token.
   */
  abstract removeTemporal(): void;
}
